module.exports = __webpack_public_path__ + "static/media/icn-comment.80e6b352.svg";